module.exports = __webpack_public_path__ + "media/images/header/logo-horizontal-e34213f81e0c4fedc3bc1816fa9e3cf1.webp";